(function () {
  'use strict';

  var CACHE_TTL_MS = 60 * 1000;

  function formatPrice(value, preformatted) {
    if (preformatted) return preformatted;
    if (value == null || value === '') return '';
    if (typeof value === 'number') return '₹' + Math.round(value);
    if (typeof value === 'string') {
      var stripped = value.replace(/,/g, '').trim();
      if (/^\d+(\.\d+)?$/.test(stripped)) return '₹' + Math.round(parseFloat(stripped));
    }
    return String(value);
  }

  function getPrice(product) {
    if (!product) return '';
    return formatPrice(product.price, product.priceFormatted);
  }

  function getComparePrice(product) {
    if (!product) return '';
    var raw = product.compareAtPrice != null ? product.compareAtPrice
            : product.compare_at_price != null ? product.compare_at_price
            : product.mrp != null ? product.mrp
            : product.originalPrice != null ? product.originalPrice
            : null;
    var formatted = product.compareAtPriceFormatted || product.compare_at_price_formatted || product.mrpFormatted;
    var out = formatPrice(raw, formatted);
    var cur = getPrice(product);
    if (!out || out === cur) return '';
    return out;
  }

  function productImage(product, fallback) {
    if (!product) return fallback || '';
    return product.imageSrc || product.image || product.imageUrl || product.featuredImage || product.featured_image || fallback || '';
  }

  function extractHandleFromPaths(paths) {
    if (!paths) return null;
    var list = Array.isArray(paths) ? paths : [paths];
    for (var i = 0; i < list.length; i++) {
      var p = list[i];
      if (typeof p !== 'string') continue;
      var m = p.match(/\/products\/([^/?#]+)/);
      if (m) return m[1];
    }
    return null;
  }

  function shopRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  // Resolve a variant id. Homepage/collection API products usually carry only a
  // handle (no variantId), so fall back to /products/{handle}.js and pick the
  // first available variant (else the first).
  function getVariantId(product) {
    if (!product) return Promise.resolve(null);
    if (product.variantId) return Promise.resolve(product.variantId);
    var handle = product.handle;
    if (!handle) return Promise.resolve(null);
    return fetch(shopRoot() + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants || !p.variants.length) return null;
        for (var i = 0; i < p.variants.length; i++) {
          if (p.variants[i].available) return p.variants[i].id;
        }
        return p.variants[0].id;
      })
      .catch(function () { return null; });
  }

  // Ask the theme's cart-drawer (and any other listeners) which sections to
  // bundle into the /cart/add.js request, so the drawer can re-render in place
  // from cart.sections[...] on the cart:change event below.
  function collectBundledSections() {
    var sections = [];
    try {
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sections }
      }));
    } catch (e) {}
    return sections;
  }

  function addToCart(variantId) {
    var sections = collectBundledSections();
    var body = { id: variantId, quantity: 1 };
    if (sections.length) {
      body.sections = sections.join(',');
      body.sections_url = window.location.pathname;
    }
    return fetch(shopRoot() + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) {
        return r.json().then(function (e) {
          throw new Error((e && e.description) || ('cart/add failed: ' + r.status));
        });
      }
      return r.json();
    });
  }

  // Add the product, then fetch the fresh cart with the bundled drawer section
  // attached. Returns { cart, items } for the caller to fire the open events.
  function addToCartWithSections(product) {
    var addResult;
    return getVariantId(product).then(function (variantId) {
      if (!variantId) throw new Error('no variant resolved');
      return addToCart(variantId);
    }).then(function (res) {
      addResult = res;
      return fetch(shopRoot() + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    }).then(function (cart) {
      if (addResult && addResult.sections) cart.sections = addResult.sections;
      var items = (addResult && addResult.items) ? addResult.items : [addResult];
      return { cart: cart, items: items };
    });
  }

  // Open the theme's cart via its native events:
  //   variant:add -> CartDrawer.show() (drawer) / CartNotificationDrawer (popover)
  //   cart:change -> drawer re-renders its bundled section in place + count bubble
  function fireCartOpen(cart, items) {
    document.documentElement.dispatchEvent(new CustomEvent('variant:add', {
      bubbles: true,
      detail: { items: items || [], cart: cart }
    }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: { baseEvent: 'variant:add', cart: cart }
    }));
  }

  function log() {
    if (window.console && console.error) console.error.apply(console, arguments);
  }

  function debug() {
    if (window.console && console.log) {
      var args = ['[shoppable-videos]'].concat(Array.prototype.slice.call(arguments));
      console.log.apply(console, args);
    }
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function cacheKey(ctx, targetId) {
    return 'bv:shoppable-videos:' + ctx + ':' + (targetId || '');
  }

  function readCache(key) {
    try {
      var raw = sessionStorage.getItem(key);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.t || Date.now() - parsed.t > CACHE_TTL_MS) {
        sessionStorage.removeItem(key);
        return null;
      }
      return parsed.d;
    } catch (e) {
      return null;
    }
  }

  function writeCache(key, data) {
    try {
      sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), d: data }));
    } catch (e) {
      /* quota exceeded — ignore */
    }
  }

  function fetchVideos(baseUrl, shopDomain, ctx, targetId) {
    var key = cacheKey(ctx, targetId);
    var cached = readCache(key);
    if (cached) return Promise.resolve(cached);

    var url = baseUrl.replace(/\/$/, '') + '/api/v1/shoppable-videos?context=' + encodeURIComponent(ctx);
    if (ctx !== 'homepage' && targetId) {
      url += '&targetId=' + encodeURIComponent(targetId);
    }

    return fetch(url, {
      method: 'GET',
      headers: { 'X-Shop-Domain': shopDomain, 'Accept': 'application/json' },
      credentials: 'omit'
    }).then(function (res) {
      if (!res.ok) {
        throw new Error('Shoppable videos request failed: ' + res.status);
      }
      return res.json();
    }).then(function (json) {
      var list = (json && json.data) || [];
      writeCache(key, list);
      return list;
    });
  }

  // Pull the trailing numeric id out of a Shopify GID (or pass a number through).
  function gidToId(gid) {
    if (gid == null) return null;
    if (typeof gid === 'number') return gid;
    var m = String(gid).match(/(\d+)\s*$/);
    return m ? parseInt(m[1], 10) : null;
  }

  // Normalise the many shapes a video's product can arrive in (nested object,
  // flat fields, PDP-injected values, or a handle derived from paths).
  function resolveProduct(video, pdpProduct) {
    var product = video.product || video.productInfo || video.productData || null;
    if (!product) {
      if (video.productTitle || video.title || video.productHandle || video.handle || video.price != null) {
        product = {
          title: video.productTitle || video.title,
          handle: video.productHandle || video.handle,
          price: video.price,
          priceFormatted: video.priceFormatted,
          compareAtPrice: video.compareAtPrice || video.compare_at_price || video.mrp || video.originalPrice,
          compareAtPriceFormatted: video.compareAtPriceFormatted || video.mrpFormatted,
          image: video.productImage || video.image || video.imageUrl,
          variantId: video.variantId || video.variant_id
        };
      }
    }
    // Each video carries its own tagged variant — prefer it over any PDP guess
    // so the correct variant is added to cart (not the product's min-price one).
    if (product && !product.variantId) {
      var taggedVariant = gidToId(video.shopifyVariantId || video.variantGid);
      if (taggedVariant) product.variantId = taggedVariant;
    }
    if (product && pdpProduct) {
      if (!product.variantId && pdpProduct.variantId) product.variantId = pdpProduct.variantId;
      if (!product.compareAtPrice && pdpProduct.compareAtPrice) product.compareAtPrice = pdpProduct.compareAtPrice;
      if (!product.handle && pdpProduct.handle) product.handle = pdpProduct.handle;
    }
    if (product && !product.handle) {
      var derivedHandle = extractHandleFromPaths(video.paths);
      if (derivedHandle) product.handle = derivedHandle;
    }
    return product;
  }

  // Live product cache (by handle) so N identical tiles trigger one fetch.
  var _liveProductCache = {};
  function fetchLiveProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (_liveProductCache[handle]) return _liveProductCache[handle];
    var p = fetch(shopRoot() + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    _liveProductCache[handle] = p;
    return p;
  }

  // Parse a numeric amount (rupees) out of a number or string like "2,399.00".
  function toAmount(v) {
    if (v == null || v === '') return null;
    if (typeof v === 'number') return v;
    var n = parseFloat(String(v).replace(/[^0-9.]/g, ''));
    return isNaN(n) ? null : n;
  }

  // Format a rupee amount as "₹4,699.00" (Indian grouping); withSymbol=false
  // drops the ₹ (used for the struck-through compare price).
  function amountStr(amt, withSymbol) {
    if (amt == null) return '';
    var s;
    try {
      s = Number(amt).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } catch (e) {
      s = String(Math.round(amt));
    }
    return withSymbol ? '₹' + s : s;
  }

  // Render the price row: optional discount badge + current + struck compare.
  // currentAmt / compareAmt are numbers in rupees (not formatted strings).
  function renderPrice(priceEl, currentAmt, compareAmt) {
    priceEl.innerHTML = '';
    var hasCompare = compareAmt != null && currentAmt != null && compareAmt > currentAmt;
    if (hasCompare) {
      var pct = Math.round((compareAmt - currentAmt) / compareAmt * 100);
      if (pct > 0) {
        var badge = document.createElement('span');
        badge.className = 'shoppable-videos__reel-card-discount';
        badge.textContent = '-' + pct + '%';
        priceEl.appendChild(badge);
      }
    }
    if (currentAmt != null) {
      var c = document.createElement('span');
      c.className = 'shoppable-videos__reel-card-price-current';
      c.textContent = amountStr(currentAmt, true);
      priceEl.appendChild(c);
    }
    if (hasCompare) {
      var k = document.createElement('span');
      k.className = 'shoppable-videos__reel-card-price-compare';
      k.textContent = amountStr(compareAmt, false);
      priceEl.appendChild(k);
    }
  }

  // Build the product card overlay (image, title, variant, price, add-to-cart)
  // shared by the rail tiles and the fullscreen reels. `onAdded` runs after a
  // successful add, before the cart drawer opens (reels use it to close).
  function createProductCard(product, video, onAdded) {
    if (!product) return null;

    var card = document.createElement('div');
    card.className = 'shoppable-videos__reel-card';

    // Image element is always created (kept as a reference) so the live variant
    // image can be swapped in later; it's only attached once it has a src.
    var img = document.createElement('img');
    img.className = 'shoppable-videos__reel-card-img';
    img.alt = product.title || '';
    img.loading = 'lazy';
    var imgSrc = productImage(product, video && video.thumbnailUrl);
    if (imgSrc) {
      img.src = imgSrc;
      card.appendChild(img);
    }

    var info = document.createElement('div');
    info.className = 'shoppable-videos__reel-card-info';

    var titleEl = document.createElement('p');
    titleEl.className = 'shoppable-videos__reel-card-title';
    titleEl.textContent = product.title || '';
    info.appendChild(titleEl);

    // Variant name (e.g. "1 lbs / Coffee") — filled from live data below.
    var variantEl = document.createElement('p');
    variantEl.className = 'shoppable-videos__reel-card-variant';
    variantEl.hidden = true;
    info.appendChild(variantEl);

    var priceEl = document.createElement('p');
    priceEl.className = 'shoppable-videos__reel-card-price';
    renderPrice(priceEl, toAmount(product.price), toAmount(product.compareAtPrice));
    info.appendChild(priceEl);
    card.appendChild(info);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'shoppable-videos__reel-card-btn';
    // Reuse the theme's animated dot loader (.button__loading + keyframes).
    btn.innerHTML = '<span class="buybutton-text">Add To Cart</span>' +
      '<span class="button__loading"><span></span><span></span><span></span></span>';
    var textEl = btn.querySelector('.buybutton-text');
    var loaderEl = btn.querySelector('.button__loading');
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      e.preventDefault();
      if (btn.disabled) return;
      btn.disabled = true;
      btn.classList.add('is-loading');
      loaderEl.classList.add('active');
      addToCartWithSections(product).then(function (data) {
        btn.classList.remove('is-loading');
        loaderEl.classList.remove('active');
        btn.disabled = false;
        if (typeof onAdded === 'function') onAdded();
        fireCartOpen(data.cart, data.items);
      }).catch(function (err) {
        log('shoppable-videos add-to-cart:', err);
        btn.classList.remove('is-loading');
        loaderEl.classList.remove('active');
        textEl.textContent = 'Add To Cart';
        btn.disabled = false;
      });
    });
    card.appendChild(btn);

    // Enrich with the real Shopify variant: accurate price + variant name.
    // (The API sends the product min-price, not the tagged variant's price.)
    if (product.handle && product.variantId) {
      fetchLiveProduct(product.handle).then(function (live) {
        if (!live || !live.variants) return;
        var variant = null;
        for (var i = 0; i < live.variants.length; i++) {
          if (live.variants[i].id === product.variantId) { variant = live.variants[i]; break; }
        }
        if (!variant) return;
        // /products/{handle}.js prices are in the smallest unit (paise) → /100.
        var compareAmt = (variant.compare_at_price && variant.compare_at_price > variant.price)
          ? variant.compare_at_price / 100 : null;
        renderPrice(priceEl, variant.price / 100, compareAmt);
        if (variant.title && variant.title !== 'Default Title') {
          variantEl.textContent = variant.title;
          variantEl.hidden = false;
        }
        // Prefer the variant image, fall back to the product's featured image.
        var liveImg = (variant.featured_image && variant.featured_image.src)
          || live.featured_image
          || (live.images && live.images[0])
          || '';
        if (liveImg) {
          img.src = liveImg;
          if (!img.parentNode) card.insertBefore(img, card.firstChild);
        }
      });
    }

    return card;
  }

  function buildTile(video, idx, pdpProduct) {
    var tile = document.createElement('div');
    tile.className = 'shoppable-videos__tile';
    tile.setAttribute('role', 'listitem');
    tile.setAttribute('data-sv-tile', '');
    tile.setAttribute('data-sv-index', String(idx));
    tile.tabIndex = 0;

    var product = resolveProduct(video, pdpProduct);
    var title = (product && product.title) || (video.product && video.product.title);
    tile.setAttribute('aria-label', title ? 'Play video for ' + title : 'Play shoppable video');

    // Video sits in its own media block (rounded top); the product info card
    // renders as a white panel below it.
    var media = document.createElement('div');
    media.className = 'shoppable-videos__tile-media';

    var v = document.createElement('video');
    v.className = 'shoppable-videos__tile-video';
    v.src = video.videoUrl;
    v.muted = true;
    v.loop = true;
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    v.setAttribute('muted', '');
    v.preload = 'metadata';
    if (video.thumbnailUrl) v.poster = video.thumbnailUrl;
    if (title) v.setAttribute('aria-label', title);

    media.appendChild(v);
    tile.appendChild(media);

    // Product info card (image + title + price + add-to-cart) below the video.
    var card = createProductCard(product, video, null);
    if (card) tile.appendChild(card);

    return tile;
  }

  function setupTileAutoplayObserver(carousel) {
    if (prefersReducedMotion()) return null;
    if (!('IntersectionObserver' in window)) return null;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var vid = entry.target.querySelector('video');
        if (!vid) return;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
          // Loop only the first 3 seconds on the rail: play 0→3s, restart.
          try { vid.currentTime = 0; } catch (e) {}
          var p = vid.play();
          if (p && p.catch) p.catch(function () {});
          if (vid._svPreviewTimer) clearInterval(vid._svPreviewTimer);
          vid._svPreviewTimer = setInterval(function () {
            try { vid.currentTime = 0; } catch (e) {}
            var rp = vid.play();
            if (rp && rp.catch) rp.catch(function () {});
          }, 3000);
        } else {
          if (vid._svPreviewTimer) {
            clearInterval(vid._svPreviewTimer);
            vid._svPreviewTimer = 0;
          }
          vid.pause();
        }
      });
    }, { root: carousel, threshold: [0, 0.6, 1] });

    return io;
  }

  /* ===== Rail carousel: prev/next arrows + dot pagination ===== */

  function setupRailNav(root, carousel) {
    var prevBtn = root.querySelector('[data-sv-rail-prev]');
    var nextBtn = root.querySelector('[data-sv-rail-next]');
    var tiles = Array.prototype.slice.call(carousel.querySelectorAll('[data-sv-tile]'));
    if (!tiles.length) return;

    var behavior = prefersReducedMotion() ? 'auto' : 'smooth';

    function update() {
      var overflow = carousel.scrollWidth - carousel.clientWidth > 4;
      root.setAttribute('data-sv-rail-overflow', overflow ? 'true' : 'false');

      var atStart = carousel.scrollLeft <= 4;
      var atEnd = carousel.scrollLeft >= carousel.scrollWidth - carousel.clientWidth - 4;
      if (prevBtn) prevBtn.disabled = atStart;
      if (nextBtn) nextBtn.disabled = atEnd;
    }

    function page(dir) {
      carousel.scrollBy({ left: dir * carousel.clientWidth * 0.8, behavior: behavior });
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { page(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { page(1); });

    var raf = 0;
    carousel.addEventListener('scroll', function () {
      if (raf) return;
      raf = window.requestAnimationFrame(function () { raf = 0; update(); });
    }, { passive: true });

    var resizeRaf = 0;
    window.addEventListener('resize', function () {
      if (resizeRaf) return;
      resizeRaf = window.requestAnimationFrame(function () { resizeRaf = 0; update(); });
    });

    update();
  }

  /* ===== Reels-style modal ===== */

  function ReelsModal(root) {
    this.root = root;
    this.modal = root.querySelector('[data-sv-modal]');
    this.track = root.querySelector('[data-sv-reels-track]');
    this.soundBtn = root.querySelector('[data-sv-sound-toggle]');
    this.soundOnIcon = root.querySelector('[data-sv-sound-on]');
    this.soundOffIcon = root.querySelector('[data-sv-sound-off]');
    this.prevBtn = root.querySelector('[data-sv-prev]');
    this.nextBtn = root.querySelector('[data-sv-next]');
    this.layout = root.dataset.layout === 'horizontal' ? 'horizontal' : 'vertical';
    this.modal.setAttribute('data-sv-layout', this.layout);
    // The horizontal carousel is desktop-only; on mobile the player behaves
    // like the vertical reels (matches the CSS @media min-width: 750px gate).
    this.desktopMql = window.matchMedia('(min-width: 750px)');
    this._scrollRaf = 0;
    this.pdpProduct = {
      handle: root.dataset.productHandle || '',
      variantId: root.dataset.productVariantId ? parseInt(root.dataset.productVariantId, 10) : null,
      price: root.dataset.productPrice || '',
      compareAtPrice: root.dataset.productCompareAtPrice || '',
      image: root.dataset.productImage || ''
    };
    this.videos = [];
    this.reels = [];
    this.observer = null;
    this.currentIndex = -1;
    this.muted = false;
    this.savedTimes = {};
    this.lastFocus = null;

    var self = this;
    Array.prototype.forEach.call(root.querySelectorAll('[data-sv-modal-close]'), function (el) {
      el.addEventListener('click', function () { self.close(); });
    });
    document.addEventListener('keydown', function (e) {
      if (self.modal.hasAttribute('hidden')) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        self.close();
      } else if (self.effectiveLayout() === 'horizontal' && (e.key === 'ArrowLeft' || e.key === 'ArrowRight')) {
        e.preventDefault();
        self.step(e.key === 'ArrowLeft' ? -1 : 1);
      }
    });
    this.soundBtn.addEventListener('click', function () {
      self.setMuted(!self.muted);
    });
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', function () { self.step(-1); });
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', function () { self.step(1); });
    }
    this.updateSoundIcon();
  }

  ReelsModal.prototype.setVideos = function (videos) {
    this.videos = videos || [];
  };

  // 'horizontal' only when the section is set to horizontal AND we're at a
  // desktop width; otherwise 'vertical' (mobile reels).
  ReelsModal.prototype.effectiveLayout = function () {
    return this.layout === 'horizontal' && this.desktopMql.matches ? 'horizontal' : 'vertical';
  };

  ReelsModal.prototype.buildReels = function () {
    this.track.innerHTML = '';
    this.reels = [];
    var self = this;

    this.videos.forEach(function (video, idx) {
      var reel = document.createElement('div');
      reel.className = 'shoppable-videos__reel';
      reel.setAttribute('data-sv-reel-index', String(idx));

      var v = document.createElement('video');
      v.className = 'shoppable-videos__reel-video';
      v.src = video.videoUrl;
      v.loop = true;
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      v.muted = self.muted;
      if (self.muted) v.setAttribute('muted', '');
      v.preload = 'metadata';
      if (video.thumbnailUrl) v.poster = video.thumbnailUrl;
      reel.appendChild(v);

      // Tap on video toggles play/pause
      v.addEventListener('click', function () {
        if (v.paused) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });

      // Product card overlay — same builder as the rail tiles. Closing the
      // reels first keeps the drawer from opening behind the fullscreen player.
      var product = resolveProduct(video, self.pdpProduct);
      var card = createProductCard(product, video, function () { self.close(); });
      if (card) reel.appendChild(card);

      self.track.appendChild(reel);

      self.reels.push({
        video: video,
        videoEl: v,
        reelEl: reel
      });
    });
  };

  ReelsModal.prototype.setupActivation = function () {
    if (this.effectiveLayout() === 'horizontal') {
      this.setupScrollActivation();
    } else {
      this.setupObserver();
    }
  };

  // Horizontal layout: reels peek on both sides, so several intersect the
  // viewport at once. Pick the one whose centre is nearest the track centre.
  ReelsModal.prototype.setupScrollActivation = function () {
    var self = this;
    this.teardownScrollActivation();

    function pickNearest() {
      self._scrollRaf = 0;
      var center = self.track.scrollLeft + self.track.clientWidth / 2;
      var best = -1;
      var bestDist = Infinity;
      for (var i = 0; i < self.reels.length; i++) {
        var el = self.reels[i].reelEl;
        var elCenter = el.offsetLeft + el.clientWidth / 2;
        var dist = Math.abs(elCenter - center);
        if (dist < bestDist) { bestDist = dist; best = i; }
      }
      if (best !== -1 && best !== self.currentIndex) self.activate(best);
    }

    this._onScroll = function () {
      if (self._scrollRaf) return;
      self._scrollRaf = window.requestAnimationFrame(pickNearest);
    };
    this.track.addEventListener('scroll', this._onScroll, { passive: true });
    pickNearest();
  };

  ReelsModal.prototype.teardownScrollActivation = function () {
    if (this._onScroll) {
      this.track.removeEventListener('scroll', this._onScroll);
      this._onScroll = null;
    }
    if (this._scrollRaf) {
      window.cancelAnimationFrame(this._scrollRaf);
      this._scrollRaf = 0;
    }
  };

  ReelsModal.prototype.setupObserver = function () {
    if (this.observer) this.observer.disconnect();
    var self = this;
    this.observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var idx = parseInt(entry.target.getAttribute('data-sv-reel-index'), 10);
        if (isNaN(idx)) return;
        var item = self.reels[idx];
        if (!item) return;

        if (entry.isIntersecting && entry.intersectionRatio >= 0.7) {
          self.activate(idx);
        } else {
          self.deactivate(idx);
        }
      });
    }, { root: this.track, threshold: [0, 0.5, 0.7, 1] });

    this.reels.forEach(function (entry) {
      self.observer.observe(entry.reelEl);
    });
  };

  ReelsModal.prototype.activate = function (idx) {
    if (this.currentIndex === idx) return;
    if (this.currentIndex !== -1) this.deactivate(this.currentIndex);

    this.currentIndex = idx;
    var entry = this.reels[idx];
    if (!entry) return;

    entry.reelEl.setAttribute('data-sv-active', '');
    // Horizontal layout: dock the sound toggle into the active tile's corner.
    if (this.effectiveLayout() === 'horizontal' && this.soundBtn) {
      entry.reelEl.appendChild(this.soundBtn);
    }
    this.updateNav();

    var v = entry.videoEl;
    var saved = this.savedTimes[idx];
    if (typeof saved === 'number' && !isNaN(saved)) {
      try { v.currentTime = saved; } catch (e) {}
    }
    v.muted = this.muted;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  };

  ReelsModal.prototype.deactivate = function (idx) {
    var entry = this.reels[idx];
    if (!entry) return;
    entry.reelEl.removeAttribute('data-sv-active');
    var v = entry.videoEl;
    if (!isNaN(v.currentTime)) this.savedTimes[idx] = v.currentTime;
    v.pause();
    if (this.currentIndex === idx) this.currentIndex = -1;
  };

  // Disable the prev/next arrows at the ends of the list (both layouts).
  ReelsModal.prototype.updateNav = function () {
    if (this.prevBtn) this.prevBtn.disabled = this.currentIndex <= 0;
    if (this.nextBtn) this.nextBtn.disabled = this.currentIndex >= this.reels.length - 1;
  };

  // Scroll the requested reel into view; activation follows from the scroll
  // observer (horizontal) or the IntersectionObserver (vertical).
  ReelsModal.prototype.goTo = function (idx) {
    var entry = this.reels[idx];
    if (!entry) return;
    var behavior = prefersReducedMotion() ? 'auto' : 'smooth';
    if (this.effectiveLayout() === 'horizontal') {
      var left = entry.reelEl.offsetLeft - (this.track.clientWidth - entry.reelEl.clientWidth) / 2;
      this.track.scrollTo({ left: left, top: 0, behavior: behavior });
    } else {
      this.track.scrollTo({ top: entry.reelEl.offsetTop, left: 0, behavior: behavior });
    }
  };

  ReelsModal.prototype.step = function (dir) {
    var base = this.currentIndex === -1 ? 0 : this.currentIndex;
    var next = base + dir;
    if (next < 0 || next >= this.reels.length) return;
    this.goTo(next);
  };

  ReelsModal.prototype.setMuted = function (muted) {
    this.muted = !!muted;
    this.reels.forEach(function (entry) {
      entry.videoEl.muted = muted;
    });
    this.soundBtn.setAttribute('aria-pressed', muted ? 'false' : 'true');
    this.updateSoundIcon();
  };

  ReelsModal.prototype.updateSoundIcon = function () {
    if (this.muted) {
      this.soundOnIcon.hidden = true;
      this.soundOffIcon.hidden = false;
    } else {
      this.soundOnIcon.hidden = false;
      this.soundOffIcon.hidden = true;
    }
  };

  ReelsModal.prototype.open = function (startIdx) {
    this.lastFocus = document.activeElement;
    this.modal.hidden = false;
    document.body.style.overflow = 'hidden';

    if (!this.reels.length) this.buildReels();

    var target = this.reels[startIdx];
    if (target) {
      // Jump to selected reel without smooth scroll first
      if (this.effectiveLayout() === 'horizontal') {
        var left = target.reelEl.offsetLeft - (this.track.clientWidth - target.reelEl.clientWidth) / 2;
        this.track.scrollTo({ left: left, top: 0, behavior: 'auto' });
      } else {
        this.track.scrollTo({ top: target.reelEl.offsetTop, left: 0, behavior: 'auto' });
      }
    }

    // Set up activation after positioning so the first pick lands on the target.
    this.setupActivation();
  };

  ReelsModal.prototype.close = function () {
    var self = this;
    this.reels.forEach(function (_, idx) {
      self.deactivate(idx);
    });
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    this.teardownScrollActivation();
    this.modal.hidden = true;
    document.body.style.overflow = '';
    if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
  };

  /* ===== Section init ===== */

  function init(root) {
    // Guard against double-init when the shell is present more than once on a
    // page (e.g. standalone section + product-info block) and boot() runs twice.
    if (root.dataset.svInitialized) return;
    root.dataset.svInitialized = '1';

    var baseUrl = root.dataset.backendBaseUrl;
    var shopDomain = root.dataset.shopDomain;
    var ctx = root.dataset.context;
    var targetId = root.dataset.targetId;
    var maxVideos = parseInt(root.dataset.maxVideos, 10) || 8;

    debug('init', { baseUrl: baseUrl, shopDomain: shopDomain, ctx: ctx, targetId: targetId, maxVideos: maxVideos });

    if (!baseUrl || !shopDomain) {
      log('shoppable-videos: missing backend base URL or shop domain');
      return;
    }

    if (ctx === 'product' && !targetId) {
      debug('aborting: product context but no targetId resolved');
      return;
    }
    if (ctx === 'collection' && !targetId) {
      debug('aborting: collection context but no targetId resolved');
      return;
    }

    fetchVideos(baseUrl, shopDomain, ctx, targetId).then(function (videos) {
      debug('fetched videos', { count: videos ? videos.length : 0 });
      if (!videos || !videos.length) {
        debug('no videos returned, section stays hidden');
        return;
      }

      var limited = videos.slice(0, maxVideos);
      var carousel = root.querySelector('[data-sv-carousel]');
      var modal = new ReelsModal(root);
      modal.setVideos(limited);
      var io = setupTileAutoplayObserver(carousel);

      limited.forEach(function (video, idx) {
        var tile = buildTile(video, idx, modal.pdpProduct);
        // Open the reels on tile click; the card's Add-to-cart button stops
        // propagation so it never opens the player.
        tile.addEventListener('click', function () { modal.open(idx); });
        tile.addEventListener('keydown', function (e) {
          if (e.target !== tile) return;
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); modal.open(idx); }
        });
        carousel.appendChild(tile);
        if (io) io.observe(tile);
      });

      root.hidden = false;
      root.setAttribute('data-sv-visible', '');
      // Measure after layout so overflow / arrows / dots reflect real widths.
      window.requestAnimationFrame(function () { setupRailNav(root, carousel); });
      debug('rendered', limited.length, 'tile(s)');
    }).catch(function (err) {
      log('shoppable-videos:', err);
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-shoppable-videos]');
    debug('boot — section roots found:', roots.length);
    Array.prototype.forEach.call(roots, init);
  }

  // The asset may be included twice (standalone section + product-info block).
  // Bind boot only once; per-root guards in init() cover any roots added later.
  if (!window.__svBooted) {
    window.__svBooted = true;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  }
})();
